import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * https://developer.chrome.com/blog/origin-trials/
 * https://github.com/GoogleChrome/OriginTrials
 */
@Injectable({
  providedIn: 'root'
})
export class RemoteControlService {
  /**
   * https://www.chromestatus.com/feature/5823036655665152
   * https://developer.chrome.com/origintrials/#/view_trial/3892235977954951169
   */
  private readonly _rtcPeerConnectionPlanBSdpSemanticsTokens = {
    'bold360.io': 'Akae0Pl3ryzmtOEUjkH+wlNIuhOr0GaaZs6jZ67DxU14y/oZs/2l7A1gFsYETrf279MDHPvdUazlWKsJ4u8vLgYAAAB3eyJvcmlnaW4iOiJodHRwczovL2JvbGQzNjAuaW86NDQzIiwiZmVhdHVyZSI6IlJUQ0V4dGVuZERlYWRsaW5lRm9yUGxhbkJSZW1vdmFsIiwiZXhwaXJ5IjoxNjQwNzM1OTk5LCJpc1N1YmRvbWFpbiI6dHJ1ZX0=',
    'bold360.com': 'AjCGYJ+2gBTVYPxHZvM1iDrRbypd6/4PfUYisdL0wSh25OWPP+SQZfpS99CHmF1gcnyuYth+Osxsq5pqACV0YAwAAAB4eyJvcmlnaW4iOiJodHRwczovL2JvbGQzNjAuY29tOjQ0MyIsImZlYXR1cmUiOiJSVENFeHRlbmREZWFkbGluZUZvclBsYW5CUmVtb3ZhbCIsImV4cGlyeSI6MTY0MDczNTk5OSwiaXNTdWJkb21haW4iOnRydWV9'
  };

  private initialized = false;

  constructor(@Inject(DOCUMENT) private _document) {
  }

  addTemporaryTrialTokens(): void {
    if (!this.initialized) {
      this.initialized = true;
      Object.values(this._rtcPeerConnectionPlanBSdpSemanticsTokens).forEach(token => this._addTemporaryTrialToken(token));
    }
  }

  private _addTemporaryTrialToken(token: string): void {
    const tokenElement = this._document.createElement('meta');
    tokenElement.httpEquiv = 'origin-trial';
    tokenElement.content = token;
    this._document.head.appendChild(tokenElement);
  }
}
